module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PleaseInputToSearch":"Please input to search"},"vi":{"PleaseInputToSearch":"Gõ tên quyền để tìm kiếm hoặc tạo mới."}}')
  delete Component.options._Ctor
}
